'use client'

import { useEffect } from 'react'

import { brand } from '@/utils/brand'

const CancellationsAndRefundsPage = (): React.JSX.Element => {
  const { contactInfo, pageTitle, policies } = brand.pageContent.CancellationsAndRefunds

  useEffect(() => {
    // Redirect to support article
    window.location.replace(
      'https://support.shipsticks.com/hc/en-us/articles/30120109245204-Cancel-My-Shipment',
    )
  }, [])

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="mb-4 text-4xl font-bold text-off-shore-navy">{pageTitle}</h1>
          <div className="h-px w-full bg-neutral-300"></div>
        </div>

        {/* Content */}
        <div className="prose prose-lg max-w-none">
          <div className="space-y-6 text-gray-700">
            {policies.map((policy, index) => (
              <p key={index} className="text-lg leading-relaxed">
                {policy.text}
              </p>
            ))}
          </div>

          {/* Contact Information */}
          <div className="mt-12 border-t border-gray-200 pt-8">
            <h2 className="mb-6 text-2xl font-semibold text-off-shore-navy">Contact Information</h2>
            <div className="space-y-4 text-gray-700">
              <p className="text-lg">
                For questions please call{' '}
                <a
                  href={contactInfo.phone.href}
                  className="font-medium text-accent-link hover:underline"
                >
                  {contactInfo.phone.number}
                </a>{' '}
                or
              </p>

              <p className="text-lg">
                Email to:{' '}
                <a
                  href={contactInfo.email.href}
                  className="font-medium text-accent-link hover:underline"
                >
                  {contactInfo.email.address}
                </a>
              </p>

              <div className="text-lg">
                <p className="mb-2">or Write to:</p>
                <div className="ml-4">
                  <p className="font-medium">{contactInfo.address.company}</p>
                  <p>{contactInfo.address.street}</p>
                  <p>{contactInfo.address.city}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CancellationsAndRefundsPage
